export function isVideo(url) {
  const videoExtensions = ["mp4", "webm", "ogg", "mov", "avi", "mkv"]; // Add more video extensions if needed
  return videoExtensions.some((extension) =>
    url?.toLowerCase().endsWith(extension)
  );
}


export const getDomainInfo = (userId) => {
  const hostname = window.location.hostname.split('.')[0];
  const predefinedDomains = ["test","test.mysocio","mysocio", "mysocio.shop", "localhost"];
  const isPredefinedDomain = predefinedDomains.includes(hostname);

  let uid = hostname;

  if (isPredefinedDomain) {
    uid = userId || null;
  }
  return { hostname, uid, isPredefinedDomain };
};


export function formatDateToCustom(dateString) {
  const date = new Date(dateString);
  if (isNaN(date)) return '';

  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const dayName = days[date.getDay()];
  const day = date.getDate();
  const monthName = months[date.getMonth()];
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12 || 12;

  return `${ dayName } ${ day } ${ monthName }, ${ year } at ${ hours }:${ minutes } ${ ampm }`;
}

